<script setup>
import { onMounted } from 'vue';
import appRehydrate from './appRehydrate/appRehydrate';
import { useAdminStore } from '@/store/admin';
import TopNavigation from '@/components/TopNavigation.vue';
import LeftNavigation from '@/components/LeftNavigation.vue';

const adminStore = useAdminStore();

onMounted(() => {
  appRehydrate();
});
</script>

<template>
  <v-app id="base">
    <v-main>
      <v-container fluid class="pt-0">
        <LeftNavigation v-if="adminStore.isAuthenticated"></LeftNavigation>
        <TopNavigation v-if="adminStore.isAuthenticated"></TopNavigation>
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<style lang="scss" scoped>
#base {
  background-color: rgba(var(--v-theme-background-primary));
}

.v-application {
  font-family: 'Roboto', sans-serif !important;
  font-weight: 400;
  font-size: 16px;
  color: rgba(var(--v-theme-text-primary));
}
</style>
